// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ly-0";